export const assignLocation = (url: string) => window.location.assign(url);
